import React, { useEffect, useState } from "react";
import axios from "axios";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const SecureFileViewer = ({ url, scale = 1.0 }) => {
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!url) return;

    let objectUrl = null;

    const loadFile = async () => {
      try {
        setLoading(true);
        setError(false);

        const response = await axios.get(url, {
          responseType: "blob",
        });

        const contentType = response.headers["content-type"];

        if (contentType.includes("pdf")) {
          setFileType("pdf");
        } else if (contentType.includes("image")) {
          setFileType("image");
        } else {
          throw new Error("Tipo de archivo no soportado");
        }

        const blob = new Blob([response.data], {
          type: contentType,
        });

        objectUrl = URL.createObjectURL(blob);

        setFileUrl(objectUrl);
      } catch (err) {
        console.error(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadFile();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url]);

  if (error || (!loading && !fileUrl)) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "auto",
          border: "1px solid #ddd",
          borderRadius: "8px",
          background: "#f5f5f5",
          display: "flex",
          justifyContent: "center",
          alignItems: loading ? "center" : "flex-start",
        }}
      >
        {loading ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px" }}>
            <div
              style={{
                width: "40px",
                height: "40px",
                border: "4px solid rgba(128, 0, 32, 0.1)",
                borderTop: "4px solid var(--main-color-vino, #800020)",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            />
            <p style={{ margin: 0, fontSize: "14px", color: "#666", fontFamily: "sans-serif" }}>
              Cargando documento...
            </p>
          </div>
        ) : (
          <>
            {/* PDF */}
            {fileType === "pdf" && fileUrl && (
              <Document
                file={fileUrl}
                onLoadError={(err) => {
                  console.error(err);
                }}
                loading={null}
              >
                <Page
                  pageNumber={1}
                  scale={scale}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              </Document>
            )}

            {/* Imagen */}
            {fileType === "image" && fileUrl && (
              <img
                src={fileUrl}
                alt="preview"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SecureFileViewer;